import { InjectionToken } from '@angular/core';

import type { ClientConfig } from '~ng-common-lib/client-config';

/** Optional common token for apps that provide resolved tenant config at bootstrap. */
export const COMMON_CLIENT_CONFIG = new InjectionToken<ClientConfig>('COMMON_CLIENT_CONFIG');
